import { makeSearch } from '@/shared/apollo-api/api/make-search';
import { getProductPage, getProductLite } from '@/shared/apollo-api/api/product-page';
import type {
  MakeSearchQueryInput,
  MakeSearchResult,
  ProductPage
} from '@/shared/apollo-api/__generated__/types';

// Composable для search функционала
export const useSearch = () => {
  const search = async (
    queryInput: MakeSearchQueryInput,
    cityId: number
  ): Promise<MakeSearchResult> => {
    try {
      const { makeSearchResponse, errors } = await makeSearch(queryInput, cityId);

      if (errors && errors.length > 0) {
        console.error('Search errors:', errors);
      }

      return makeSearchResponse;
    } catch (error) {
      console.error('Search error:', error);
      throw error;
    }
  };

  return {
    search,
  };
};

// Composable для product page
export const useProductPage = () => {
  const fetchProductPage = async (productId: number, cityId: number): Promise<ProductPage> => {
    try {
      const result = await getProductPage(productId, cityId);
      return result.data;
    } catch (error) {
      console.error('Product page error:', error);
      throw error;
    }
  };

  return {
    fetchProductPage,
  };
};

// Composable для облегчённого запроса продукта (shop_id, photos)
export const useProductLite = () => {
  const fetchProductLite = async (productId: number) => {
    try {
      return await getProductLite(productId);
    } catch (error) {
      console.error('Product lite error:', error);
      throw error;
    }
  };

  return {
    fetchProductLite,
  };
};
